import './style.css';

export default function TableCentered({ children }: { children: JSX.Element }) {
  return <div className="table-centered">{children}</div>;
}
